<template>
  <b-container>
    <ObjectListTabs>
      <template slot-scope="{}">
        <b-nav-item :to="{name: navlinks[type].edit.routeName, params: {id: object.id}}" v-if="object && object.id">{{ navlinks[type].edit.label }}</b-nav-item>
        <b-nav-item :to="{name: navlinks[type].create.routeName}" v-else>{{ navlinks[type].create.label }}</b-nav-item>
        <b-nav-item :to="{name: navlinks[type].commentsRouteName, params: {id: object.id}}" v-if="object && object.id">Manage Comments</b-nav-item>
      </template>
    </ObjectListTabs>

    <h1 v-if="object">{{ object.title }}</h1>

    <Comments :video="object" :canManage="true" v-if="type === 'video'" />
    <Comments :live="object" :canManage="true" v-if="type === 'live'" />
 </b-container>
</template>

<style scoped lang="scss">
    h1 {
      font-size: 1.5em;
    }
</style>

<script>
import ObjectListTabs from '@/components/widgets/ObjectListTabs'
import Comments from '@/components/widgets/Comments'

export default {
  name: 'ManageComments',
  components: {
    ObjectListTabs,
    Comments
  },
  data () {
    return {
      object: null
    }
  },
  computed: {
    type () {
      return this.$route.meta.contentType
    },
    navlinks () {
      return {
        video: {
          edit: {
            routeName: 'artist-video-edit',
            label: 'Edit Video'
          },
          create: {
            routeName: 'artist-video-create',
            label: 'Upload Video'
          },
          commentsRouteName: 'artist-video-manage-comments'
        },
        live: {
          edit: {
            routeName: 'artist-live-stream-edit',
            label: 'Edit Live Stream'
          },
          create: {
            routeName: 'artist-live-stream-create',
            label: 'Create Live Stream'
          },
          commentsRouteName: 'artist-live-stream-manage-comments'

        }
      }
    }
  },
  created () {
    this.initComponent()
  },
  watch: {
    'route': 'initComponent'
  },
  methods: {
    async initComponent () {
      if (this.type === 'video') {
        this.object = await this.$store.dispatch('song/getOwnSong', {id: this.$route.params.id})
      } else if (this.type === 'live') {
        this.object = await this.$store.dispatch('live/getOwnLiveEvent', {id: this.$route.params.id})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/artist/ManageComments.vue